import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "../css/BoardDetail.css";

const BoardDetail = () => {
  const { id } = useParams(); // URL에서 게시글 ID를 가져옴
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [comments, setComments] = useState([]); // 댓글 상태
  const [newComment, setNewComment] = useState(""); // 새 댓글 입력 상태
  const [likes, setLikes] = useState(0); // 좋아요 수 상태
  const [editMode, setEditMode] = useState(false); // 수정 모드 상태
  const [title, setTitle] = useState(""); // 수정 제목 상태
  const [content, setContent] = useState(""); // 수정 내용 상태
  const loggedInUserId = localStorage.getItem("user_id"); // 로그인한 사용자의 ID 가져오기

  // 게시글 데이터 불러오기
  useEffect(() => {
    const fetchPost = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`http://35.192.131.111/board/${id}/`);

        if (response.data.result) {
          setPost(response.data.data);
          setTitle(response.data.data.title); // 제목과 내용 상태 초기화
          setContent(response.data.data.content);
        } else {
          setError("게시글을 불러오는 데 실패했습니다.");
        }
        setLoading(false);
      } catch (err) {
        setError("게시글을 불러오는 데 실패했습니다.");
        setLoading(false);
      }
    };

    fetchPost();
  }, [id]);

  // 게시물 수정 함수
  const handleEdit = async () => {
    try {
      const response = await axios.put(
        `http://35.192.131.111/board/${id}/`,
        { title, content },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.data.result) {
        setPost({ ...post, title, content });
        setEditMode(false);
      } else {
        setError("게시글 수정에 실패했습니다.");
      }
    } catch (error) {
      setError("게시글 수정 중 오류가 발생했습니다.");
    }
  };

  // 게시물 삭제 함수
  const handleDelete = async () => {
    try {
      const response = await axios.delete(
        `http://35.192.131.111/board/${id}/`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );

      if (response.status === 204) {
        // 204: 성공적으로 삭제됨
        alert("게시글이 삭제되었습니다.");
        navigate("/board"); // 삭제 후 게시판 페이지로 이동
      } else {
        setError("게시글 삭제에 실패했습니다.");
      }
    } catch (error) {
      setError("게시글 삭제 중 오류가 발생했습니다.");
    }
  };

  // 댓글 추가 함수
  const addComment = () => {
    if (newComment.trim()) {
      setComments([...comments, newComment]);
      setNewComment(""); // 입력란 초기화
    }
  };

  // 좋아요 증가 함수
  const handleLike = () => {
    setLikes(likes + 1);
  };

  if (loading) return <p>로딩 중...</p>;
  if (error) return <p>{error}</p>;
  if (!post) return <p>게시글이 존재하지 않습니다.</p>;

  const isAuthor = post.user_id === loggedInUserId; // 게시글 작성자인지 확인

  return (
    <div className="board-detail">
      <div className="Board-Table">
        <table className="DetailTable">
          <thead>
            <tr>
              <th>
                {editMode ? (
                  <input
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                ) : (
                  <h2>{post.title}</h2>
                )}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p>작성자:</p>
              </td>
              <td>{post.user}</td>
              <td>작성일:</td>
              <td>{new Date(post.created_At).toLocaleString()}</td>
            </tr>
            <tr>
              <td>
                <p>게시글 ID:</p>
              </td>
              <td>
                <p>{post.board_id}</p>
              </td>
              <td>
                <p>수정일: </p>
              </td>
              <td>
                <p>{new Date(post.updated_At).toLocaleString()}</p>
              </td>
            </tr>
            <tr className="Content-Table">
              <td colSpan={4}>
                {editMode ? (
                  <textarea
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                  />
                ) : (
                  post.content
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* 수정 및 삭제 버튼 */}
      <div className="button-section">
        {editMode ? (
          <>
            <button onClick={handleEdit}>저장하기</button>
            <button onClick={() => setEditMode(false)}>취소</button>
          </>
        ) : (
          <>
            <button onClick={() => setEditMode(true)}>수정하기</button>
            <button onClick={handleDelete}>삭제하기</button>
          </>
        )}
      </div>

      {/* 좋아요 버튼 및 카운트 */}
      <div className="likes-section">
        <button onClick={handleLike}>👍 좋아요</button>
        <p>좋아요: {likes}</p>
      </div>

      {/* 댓글 입력 및 목록 */}
      <div className="comments-section">
        <h3>댓글</h3>
        <input
          type="text"
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder="댓글을 입력하세요."
        />
        <button onClick={addComment}>입력</button>

        <div className="comments-list">
          {comments.length > 0 ? (
            comments.map((comment, index) => <p key={index}>{comment}</p>)
          ) : (
            <p>댓글이 없습니다.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default BoardDetail;
